import Carousel from '../../FancyApps/Carousel';
import slideItems from '../../Data/BannerImgs/imagenes';

function Gallery() {
  return (
    <>
      <Carousel>
        {slideItems.map((item) => (
          <li key={item.id} className={`carousel__slide text-transparent`}>
            <img
              loading="lazy"
              decoding="async"
              className="w-96 sm:w-full h-96 sm:h-[300px] md:h-[350px] lg:h-[400px] xl:h-[450px] object-cover rounded-full opacity-75"
              src={item.bigImg}
              alt={item.id}
            />
          </li>
        ))}
      </Carousel>
      <div className="py-36"></div>
    </>
  );
}

export default Gallery;
